"use client"
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import useDownloader from "react-use-downloader";
import styles from "@/app/styles/components/pages/corporate-gifts/corporate-gifts-catalog.module.scss";

const CorporateGiftsCatalog = ({ data }) => {
    return (
        <div className={styles.corporateGiftsCatalogMain}>
            <div className="container">
                <div className={styles.contentContainer}>
                    <h2 className={styles.title}>{data.catalog_title}</h2>
                    <Link target="_blank" href={data.catalog_file} rel="noopener" download className={styles.link}>
                        <FormattedMessage id={'components.pages.corporateGifts.catalog.download'}/>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default CorporateGiftsCatalog

